<template>
    <div>
        <base-header>
            <b-row align-v="center" class="py-4">
                <b-col lg="6" cols="7">
                    <h6 class="h2 text-white d-inline-block mb-0">Financial Proposal</h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </b-col>
                <b-col cols="6" class="text-right">
                    <base-button v-show="backButton" type="primary" icon size="sm" @click="close()">
                        <span class="btn-inner--text">Back / Close</span>
                    </base-button>
                </b-col>
            </b-row>
        </base-header> 
        <b-container fluid class="mt--6">
            <pdf-download-reports-table></pdf-download-reports-table>
        </b-container>
    </div>
</template>
<script>
    import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';
    import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
    import PdfDownloadReportsTable from "@/views/FinancialProposal/PdfDownloadReportsFolder/PdfDownloadReportsTable";

    export default {
        components: {
            PdfDownloadReportsTable,
            RouteBreadCrumb,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn
        },
        data() {
            return {
                backButton: false,
            };
        },
        created() {
            if(this.$route.params.token)
            {
                this.backButton = true;
            }
        },
    }
</script>